import { DirectorAuthority, RepresentationAuthority } from 'generated/gql';
import { t } from '@lingui/macro';

const directorAuthorityLabels = {
  [DirectorAuthority.Jointly]: () => t`Gezamenlijk bevoegd`,
  [DirectorAuthority.Solely]: () => t`Alleen bevoegd`,
};

export const formatDirectorAuthority = (authority: DirectorAuthority) =>
  directorAuthorityLabels[authority]();

const representationAuthorityLabels = {
  [RepresentationAuthority.Limited]: () => t`Beperkte vertegenwoordigingsbevoegdheid`,
  [RepresentationAuthority.Unlimited]: () => t`Onbeperkte vertegenwoordigingsbevoegdheid`,
};

export const formatRepresentationAuthority = (representationAuthority: RepresentationAuthority) =>
  representationAuthorityLabels[representationAuthority]();
